<template>
  <div class="workspace-selector">
    <button
        v-for="client in clientList"
        :key="client.clientId"
        type="button"
        class="workspace-option"
        :class="{ 'is-current': isCurrent(client) }"
        :aria-current="isCurrent(client) ? 'true' : null"
        @click.stop="handleClientSelection(client)"
    >
      <span class="workspace-avatar">{{ getClientInitials(client.clientName) }}</span>
      <span class="workspace-name">{{ client.clientName }}</span>
      <portal-icon
          v-if="isCurrent(client)"
          name="check"
          :size="17"
          class="workspace-check"
      ></portal-icon>
    </button>
  </div>
</template>

<script>
import PortalIcon from '@/components/PortalIcon.vue';

export default {
  name: "WorkspaceSelector",

  props: [],

  components: { PortalIcon },

  methods: {
    handleClientSelection(client) {
      if (this.isCurrent(client)) {
        return;
      }

      this.$store.commit('setSelectedClient',client.clientId);
      localStorage.setItem('SELECTED_CLIENT',client.clientId);
      window.location.href = "/";
    },

    isCurrent(client) {
      return client && client.clientId === this.$store.getters.getClientId;
    },

    getClientInitials(clientName) {
      if(!clientName){
        return '?'
      }
      let ignoreMe = ['a', 'an', 'as', 'to', 'and', 'of', 'if', 'in', 'the', '-'];
      return clientName
          .toLowerCase()
          .split(/\s+/)
          .filter((word) => word && !ignoreMe.includes(word))
          .slice(0, 3)
          .map((word) => word.substring(0, 1))
          .join('')
          .toUpperCase();
    },
  },

  computed: {
    clientList() {
      return this.$store.getters.getClientAccounts || [];
    },
  },
}
</script>

<style scoped lang="scss">
  .workspace-selector {
    max-height: min(260px, 40vh);
    display: grid;
    gap: 3px;
    overflow-y: auto;
  }

  .workspace-option {
    width: 100%;
    min-height: 52px;
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 7px 9px;
    border: 0;
    border-radius: var(--brand-button-radius, 12px);
    background: transparent;
    color: var(--portal-text);
    font: inherit;
    text-align: left;
    cursor: pointer;
    transition: background-color 140ms ease, color 140ms ease;
  }

  .workspace-option:hover {
    background: var(--v-gray_20-base);
  }

  .workspace-option:focus-visible {
    outline: 2px solid var(--v-primary-base);
    outline-offset: -2px;
  }

  .workspace-option.is-current {
    background: color-mix(in srgb, var(--v-primary-base) 9%, transparent);
    color: var(--portal-text);
    cursor: default;
  }

  .workspace-avatar {
    width: 34px;
    height: 34px;
    flex: 0 0 34px;
    display: grid;
    place-items: center;
    border-radius: 11px;
    background: color-mix(in srgb, var(--v-primary-base) 13%, var(--portal-surface));
    color: var(--v-primary-base);
    font-size: 12px;
    font-weight: 720;
    letter-spacing: 0.035em;
  }

  .workspace-name {
    min-width: 0;
    flex: 1;
    overflow: hidden;
    font-size: 13px;
    font-weight: 650;
    line-height: 1.25;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .workspace-check {
    flex: 0 0 auto;
    color: var(--v-primary-base);
  }

  @media (prefers-reduced-motion: reduce) {
    .workspace-option {
      transition: none;
    }
  }
</style>
